import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { T as Text } from '../Text/Text-BVGlY4So.js';

const tabUnderline = /*#__PURE__*/css(["position:absolute;content:'';margin:0;bottom:0;left:0;right:0;height:", ";background:", ";border-radius:", ";"], ({
  theme
}) => theme.tabbedNavigation.highlight.height, ({
  theme
}) => theme.tabbedNavigation.highlight.color, ({
  theme
}) => theme.tabbedNavigation.highlight.radius);
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-0"
})(["position:relative;border-bottom:", ";background:", ";padding-block-start:", ";padding-inline:", ";", ";"], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.surface.subtleOffset, ({
  theme
}) => theme.spacing.xxxsmall, ({
  theme
}) => theme.spacing.small.default, ({
  theme,
  isTabOverflow
}) => isTabOverflow && isMobile(css(["::after{position:absolute;height:calc(100% - 1px);width:", ";/*! @noflip */ border-radius:0 ", " 0 0;left:auto;inset-inline-start:auto;right:0;inset-inline-end:0;top:0;content:\" \";background:", ";}/*! @noflip */ [dir=\"rtl\"] &&::after{background:", ";/*! @noflip */ border-radius:", " 0 0 0;right:auto;inset-inline-start:auto;left:0;inset-inline-end:0;}"], theme.tabbedNavigation.scrollIndicatorWidth, theme.border.radius.large, theme.tabbedNavigation.scrollIndicatorRight, theme.tabbedNavigation.scrollIndicatorLeft, theme.border.radius.large)));
const TabGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-1"
})(["display:block;", ""], isMobile(css(["overflow-x:scroll;::-webkit-scrollbar{display:none;}scrollbar-width:none;"])));

// Styled component representing the Tab Group.
const TabGroup = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-2"
})(["box-sizing:border-box;display:flex;flex-wrap:wrap;align-items:stretch;margin-bottom:10px;list-style:none;padding:0;margin:0;column-gap:", ";", ""], ({
  theme
}) => theme.spacing.base.default, isMobile(css(["white-space:nowrap;flex-wrap:nowrap;column-gap:", ";"], ({
  theme
}) => theme.spacing.base.mobile)));
TabGroup.displayName = 'TabGroup';
const DefaultText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-3"
})(["::after{display:block;content:\"", "\";height:0;visibility:hidden;overflow:hidden;user-select:none;pointer-events:none;font-weight:bold;@media speech{display:none;}}"], ({
  $label
}) => $label || '');
DefaultText.displayName = 'DefaultText';
// Styled component representing the Tab.
const Tab = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-4"
})(["background:", ";display:inline-block;list-style-type:none;color:", ";text-align:left;text-align:start;outline:none;padding:0px;position:relative;border:none;", " ", " :focus-visible::after{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;", " z-index:1;pointer-events:none;", "}"], ({
  theme
}) => theme.surface.subtleOffset, ({
  theme
}) => theme.text.color.secondary, ({
  theme,
  isActive
}) => isActive && css(["color:", ";border-inline-start:none;border-inline-end:none;border-top:none;"], theme.text.color.default), ({
  theme,
  isActive
}) => !isActive && css(["border:none;:hover{color:", ";cursor:pointer;}"], theme.tabbedNavigation.text.color.hover), focusOutline, isMobile(css(["outline-offset:-2px;"])));
Tab.displayName = 'Tab';

// Styled component for the space after the tabs with border bottom
const TabRemainSpace = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-5"
})(["background:", ";width:100%;flex:1;/*! @noflip */ border-radius:0 ", " 0 0;/*! @noflip */ [dir=\"rtl\"] &{/*! @noflip */ border-radius:", " 0 0 0;}", ""], ({
  theme
}) => theme.surface.subtleOffset, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, isMobile(css(["padding-inline-end:", ";"], ({
  theme
}) => theme.tabbedNavigation.scrollIndicatorWidth)));
const TabWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40021409__sc-yhkqwq-6"
})(["padding-inline-start:0;padding-inline-end:0;padding-block-start:", ";padding-block-end:", ";", " ", " ", ""], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["padding-block-start:", ";padding-block-end:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile)), ({
  $isActive
}) => $isActive && css(["::after{", "}"], tabUnderline), ({
  $isActive
}) => !$isActive && css([":hover::after{", "}"], tabUnderline));

export { DefaultText as D, TabGroupWrapper as T, Wrapper as W, TabGroup as a, TabRemainSpace as b, Tab as c, TabWrapper as d };
//# sourceMappingURL=TabbedCard.styles-BP-AanDq.js.map
